<template>
    <div class="content-wrapper">
        <loading :active.sync="payloading" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-8">
                        <h1 class="m-0">Apply for a Loan</h1>
                    </div>
                    <div class="col-sm-4">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/apply-loan">
                                    <p>Apply for a Loan</p>
                                </router-link>
                            </li>
                            <!-- <li class="breadcrumb-item active">B2C - {{refFilter(loan_cat, 'loan_type', loan_process.loan_type, 'loan_desc')}}</li> -->
                            <li class="breadcrumb-item active">13th Month</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <!-- main content -->
        <div class="container-fluid">
            <steps :formIndicator="loan_process" :currentStep="loan_process.step" v-if="loan_process.step" />

            <s1-q1 :formLoan="formLoan" @next="submitS1Q1" @back="backS1Q1" v-if="loan_process.step==1 && loan_process.progress=='S1Q1' && formArr.length" />
            <s1-q2 :formLoan="formLoan" @next="submitS1Q2" @back="backS1Q2" v-if="loan_process.step==1 && loan_process.progress=='S1Q2' && formArr.length" />

            <s2-q1 :formLoan="formLoan" @next="submitS2Q1" @back="backS2Q1" v-if="loan_process.step==2 && loan_process.progress=='S2Q1' && formArr.length" />
            <s2-q2 :formLoan="formLoan" @next="submitS2Q2" @back="backS2Q2" v-if="loan_process.step==2 && loan_process.progress=='S2Q2' && formArr.length" />

            <s2-q3 :formLoan="formLoan" @next="submitS2Q3" @back="backS2Q3" v-if="loan_process.step==2 && loan_process.progress=='S2Q3' && formArr.length" />
            <s3-q1 :formLoan="formLoan" @next="submitS3Q1" @back="backS3Q1" v-if="loan_process.step==3 && loan_process.progress=='S3Q1' && formArr.length" />
            <s3-q2 :formLoan="formLoan" @next="submitS3Q2" @back="backS3Q2" v-if="loan_process.step==3 && loan_process.progress=='S3Q2' && formArr.length" />
            <s4-q1 :formLoan="formLoan" :user="user" v-if="loan_process.step==4 && loan_process.progress=='S4Q1' && formArr.length" />
            <s4-q2 :formLoan="formLoan" :user="user" v-if="loan_process.step==4 && loan_process.progress=='S4Q2' && formArr.length" />
            <s5-q1 :formLoan="formLoan" @back="backS5Q1" v-if="loan_process.step==5 && loan_process.progress=='S5Q1' && formArr.length" />
        </div>
        <!-- /main content -->
    </div>
</template>
<script>
    import Steps from '../section/Steps.vue';

    //built-in jsons
    // import loan_cat from '../../../../json/loan_cat.json'
    // import loan_cat from '../../../json/loan_cat.json'


    import loan_cat from '@json/loan_cat.json'



    import s1q1 from './forms/S1-Q1.vue';
    import s1q2 from './forms/S1-Q2.vue';
    import s2q1 from './forms/S2-Q1.vue';
    import s2q2 from './forms/S2-Q2.vue';

    import s2q3 from './forms/S2-Q3.vue';
    import s3q1 from './forms/S3-Q1.vue';
    import s3q2 from './forms/S3-Q2.vue';
    import s4q1 from './forms/S4-Q1.vue';
    import s4q2 from './forms/S4-Q2.vue';
    import s5q1 from './forms/S5-Q1.vue';

    export default {
        beforeRouteEnter(to, from, next) {
            if (from.path === '/apply-loan') {
                next();
            } else {
                next({
                    path: '/apply-loan'
                })
            }
        },
        components: {
            'steps': Steps,
            's1-q1': s1q1,
            's1-q2': s1q2,

            's2-q1': s2q1,
            's2-q2': s2q2,

            's2-q3': s2q3,
            's3-q1': s3q1,
            's3-q2': s3q2,
            's4-q1': s4q1,
            's4-q2': s4q2,
            's5-q1': s5q1,
        },

        data() {
            return {
                user: [],
                loan_process: [],
                payloading: false,
                loan_cat: loan_cat,
                submitting: false,


                formArr: [],

                formLoan: new Form({
                    borrower_id: null,
                    application_id: null,
                    fil: null,
                    bus_year: null,
                    bt_code: null,
                    loan_cat: null,
                    bus_id: null,
                    business_name: null,
                    start_date: null,
                    s_start_date: null,
                    province_code: null,
                    city_code: null,
                    bcode: null,
                    bldg: null,
                    street_address: null,
                    areacode: null,
                    asset_size: null,
                    annual_sale: null,
                    tin: null,
                    prev_reg_emp: null,
                    prev_contract_emp: null,
                    current_reg: null,
                    current_contract: null,

                    req_loan_amt: null,
                    req_loan_term: null,
                    grace_period: null,
                    service_fee: null,
                    install_fee: null,
                    monthly: null,

                    manner_rel: null,
                    bankname: null,
                    acctname: null,

                    bus_reg_city: null,
                    bus_reg_province: null,
                    bus_reg_date: null,
                    bus_reg_cityname: null,
                    bus_reg_provincename: null,
                    nbuss_code: null,
                    bir: null,
                    permit2019: null,
                    current_permit: null,
                    emp13: null,
                    avail13: null,
                }),
                business_info: [],


            }
        },

        created() {
            this.getInit();

            Fire.$on('getLoanReq', () => {
                this.getLoanReq(this.formLoan.application_id);
            });
        },
        methods: {
            async backS5Q1() {
                this.updateStep(4, 'S4Q2');
            },

            async backS3Q2() {
                const form = {
                    application_id: this.formLoan.application_id,
                    manner_rel: "",
                    bankname: "",
                    acctname: "",
                    acctno: "",
                };
                let x = await this.updateLoanApp(form);
                if (x == 200) {
                    this.updateStep(3, 'S3Q1');
                    Fire.$emit('getLoanReq');
                }
            },

            async submitS3Q2() {
                const form = {
                    application_id: this.formLoan.application_id,
                    manner_rel: this.formLoan.manner_rel,
                    bankname: this.formLoan.bankname,
                    acctname: this.formLoan.acctname.toUpperCase(),
                    acctno: this.formLoan.acctno
                };
                let x = await this.updateLoanApp(form);

                if (x == 200) {
                    this.updateStep(4, 'S4Q1');
                }
            },
            async backS3Q1() {
                const form = {
                    application_id: this.formLoan.application_id,
                    req_loan_amt: "",
                    req_loan_term: "",
                    grace_period: "",
                    service_fee: "",
                    install_fee: "",
                    repayment_mode: "",
                };
                let x = await this.updateLoanApp(form);


                const form2 = {
                    application_id: this.formLoan.application_id,
                    current_permit: "",
                    avail13: "",
                };

                if (x == 200) {
                    let y = await this.updateLoanReq(form2);
                    if (y == 200) {
                        this.updateStep(2, 'S2Q3');
                        Fire.$emit('getLoanReq');
                    }
                }
            },
            async submitS3Q1() {
                const form = {
                    application_id: this.formLoan.application_id,
                    req_loan_amt: this.formLoan.req_loan_amt,
                    req_loan_term: this.formLoan.req_loan_term,
                    grace_period: this.formLoan.grace_period,
                    service_fee: this.formLoan.service_fee,
                    install_fee: this.formLoan.install_fee,
                    repayment_mode: 4,
                };
                const form2 = {
                    application_id: this.formLoan.application_id,
                    avail13: this.formLoan.avail13,
                    current_permit: this.formLoan.current_permit,
                    bir: this.formLoan.bir,
                };
                let x = await this.updateLoanApp(form);

                if (x == 200) {
                    let y = await this.updateLoanReq(form2);
                    if (y == 200) {
                        this.updateStep(3, 'S3Q2');
                    }
                }
            },
            updateLoanApp(form) {
                this.payloading = true;
                return axios.post('/api/v2-update-loan-app', form)
                    .then(res => {
                        this.payloading = false;
                        return res.status
                    }).catch(err => {
                        this.payloading = false;
                        return err.response.status
                    })
            },
            async backS2Q3() {
                const form = {
                    application_id: this.formLoan.application_id,
                    prev_reg_emp: "",
                    prev_contract_emp: "",
                    current_reg: "",
                    current_contract: "",
                    max_loan: "",
                    bir: "",
                    permit2019: "",
                    current_permit: "",
                };
                let x = await this.updateLoanReq(form);
                if (x == 200) {
                    this.updateStep(2, 'S2Q2');
                    Fire.$emit('getLoanReq');
                }
            },
            async submitS2Q3() {
                const form = {
                    application_id: this.formLoan.application_id,
                    prev_reg_emp: this.formLoan.prev_reg_emp,
                    prev_contract_emp: this.formLoan.prev_contract_emp,
                    current_reg: this.formLoan.current_reg,
                    current_contract: this.formLoan.current_contract,
                    max_loan: this.formLoan.max_loan,
                    // bir: this.formLoan.bir,
                    // permit2019: this.formLoan.permit2019,
                    // current_permit: this.formLoan.current_permit,
                };
                let x = await this.updateLoanReq(form);

                if (x == 200) {
                    this.updateStep(3, 'S3Q1');
                }

            },

            // BIR
            async submitS2Q2() {
                const form = {
                    application_id: this.formLoan.application_id,
                    asset_size: this.formLoan.asset_size,
                    annual_sale: this.formLoan.annual_sale,
                    max_loan: this.formLoan.max_loan,
                    // bir: this.formLoan.bir,
                    // permit2019: this.formLoan.permit2019,
                    // current_permit: this.formLoan.current_permit,
                    // tin: this.formLoan.tin,
                };
                let x = await this.updateLoanReq(form);
                if (x == 200) {
                    this.updateStep(2, 'S2Q3');
                }
            },
            async backS2Q2() {
                const form = {
                    application_id: this.formLoan.application_id,
                    bir: "",
                    asset_size: "",
                    // annual_sale: "",
                    tin: "",
                };
                let x = await this.updateLoanReq(form);
                if (x == 200) {
                    this.updateStep(2, 'S2Q1');
                    Fire.$emit('getLoanReq');
                }
            },


            async postS2Q1() {
                const form = {
                    borrower_id: this.formLoan.borrower_id,
                    bt_code: this.formLoan.bt_code,
                    business_name: this.formLoan.business_name,
                    total_years: this.formLoan.total_years,
                    start_date: this.formLoan.s_start_date,
                    bcode: this.formLoan.bcode,
                    bldg: this.formLoan.bldg,
                    street_address: this.formLoan.street_address,
                    application_id: this.formLoan.application_id,
                    bus_id: this.formLoan.bus_id,
                    areacode: this.formLoan.areacode,
                    // nbuss_code: this.formLoan.nbuss_code,
                    loan_bus_code: this.formLoan.loan_bus_code
                };
                let x = await this.updateBusInfo(form);
                if (x == 200) {
                    this.updateStep(2, 'S2Q2');
                }
            },


            backS2Q1() {
                this.updateStep(1, 'S1Q2');
            },


            submitS2Q1() {
                axios.get('/api/v2-check-exist-b2c', {
                        params: {
                            borrower_id: this.formLoan.borrower_id,
                            application_id: this.formLoan.application_id,
                            bus_id: this.formLoan.bus_id,
                            business_name: this.formLoan.business_name,
                            bt_code: this.formLoan.bt_code
                        }
                    })
                    .then(res => {

                        let msg = res.data.msg;
                        let status = res.data.status;


                        this.formLoan.account_name = (this.formLoan.bt_code == 'BT2020001') ? this.formLoan.acctname : this.formLoan.business_name;
                        this.postS2Q1();

                        // if (status == 1) {
                        //     this.formLoan.account_name = (this.formLoan.bt_code == 'BT2020001') ? this.formLoan.acctname : this.formLoan.business_name;
                        //     this.postS2Q1();
                        // } else {
                        //     Swal.fire({
                        //         icon: 'info',
                        //         text: `${msg}`,
                        //         title: 'Notice',
                        //         allowEscapeKey: false,
                        //         allowOutsideClick: false,
                        //     }).then((result) => {
                        //         if (result.value) {
                        //             return status == 2 ? false : this.$router.push('/dashboard');
                        //         }
                        //     })
                        // }
                    }).catch(err => {

                    })
            },
            updateBusInfo(form) {
                this.payloading = true;
                return axios.post('/api/v2-post-bus-info-staple', form)
                    .then(res => {

                        let data = res.data
                        this.formLoan.bus_id = data.bus_id;
                        this.payloading = false;
                        return res.status
                    }).catch(err => {
                        this.payloading = false;
                        return err.response.status
                    })
            },


            async backS1Q2() {
                const form = {
                    application_id: this.loan_process.application_id,
                    bus_year: "",
                };
                let x = await this.updateLoanReq(form);

                if (x == 200) {
                    this.updateStep(1, 'S1Q1');
                    Fire.$emit('getLoanReq');
                }
            },
            async submitS1Q2() {
                const form = {
                    application_id: this.loan_process.application_id,
                    bus_year: this.formLoan.bus_year,
                };
                let x = await this.updateLoanReq(form);
                if (x == 200) {
                    this.updateStep(2, 'S2Q1');
                }
            },



            async backS1Q1() {
                this.deleteLoanApp();
            },

            deleteLoanApp() {
                this.payloading = true;
                axios.delete('/api/v2-del-loan-app', {
                        params: {
                            application_id: this.formLoan.application_id,
                        }
                    })
                    .then(res => {
                        this.payloading = false;
                        this.$router.push('/apply-loan');
                    }).catch(err => {
                        this.payloading = false;
                    })
            },


            async submitS1Q1() {
                const form = {
                    application_id: this.loan_process.application_id,
                    filipino: this.formLoan.fil,
                };
                let x = await this.updateLoanReq(form);

                if (x == 200) {
                    this.updateStep(1, 'S1Q2');
                }

            },
            updateLoanReq(form) {
                this.payloading = true;
                return axios.post('/api/v2-update-loan-req', form)
                    .then(res => {
                        this.payloading = false;
                        return res.status
                    }).catch(err => {
                        this.payloading = false;
                        return err.response.status
                    })
            },
            async updateStep(s, p) {
                this.payloading = true;
                return await axios.post('/api/v2-update-app-step', {
                        application_id: this.loan_process.application_id,
                        step: s,
                        progress: p
                    })
                    .then(res => {
                        let data = res.data
                        this.payloading = false;
                        this.loan_process = data.loan_process;
                        return res.status
                    }).catch(err => {
                        this.payloading = false;
                        return err.response.status
                    })
            },

            notQualified() {
                Swal.fire({
                    icon: 'warning',
                    title: 'Disqualified',
                    text: 'You are not qualified to apply in the existing program',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                })
            },

            setDataObj(temp, data) {
                let obj = {}
                for (var key in temp) {
                    // if (data[key]) {}
                    obj[key] = data[key];
                }
                return obj;
            },

            getLoanReq(app_id) {
                this.payloading = true;
                axios.get("/api/v2-b2c-loan-req", {
                        params: {
                            application_id: app_id,
                        }
                    })
                    .then(res => {
                        let data = res.data
                        // this.formLoan = data[0];
                        this.formLoan = this.setDataObj(this.formLoan, data[0]);
                        this.formArr = data;
                        this.payloading = false;
                    })
                    .catch(err => {
                        this.payloading = false;
                        console.log(err);
                    });
            },
            getInit() {
                this.payloading = true;
                axios.get("/api/v2-init-apply-loan-b2c")
                    .then(res => {
                        let data = res.data
                        this.user = data.user;
                        if (data.loan_process) {
                            this.loan_process = data.loan_process;
                            this.getLoanReq(data.loan_process.application_id);
                        } else {
                            this.$router.push('/apply-loan');
                        }

                        this.payloading = false;
                    })
                    .catch(err => {
                        this.payloading = false;
                        console.log(err);
                    });
            },
            refFilter(obj, key, val, equiv) {
                let data = obj.find(i => i[key] == val);
                return data ? data[equiv] : '';
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }
</style>